import script from "./SlotResourceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotResourceForm.vue?vue&type=script&setup=true&lang=js"

import "./SlotResourceForm.vue?vue&type=style&index=0&id=2617a791&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2617a791"]])

export default __exports__